module.exports = __webpack_public_path__ + "media/images/mypage/icon/green/ico_seminar-6ad267d3e6a24df55dc0b42b564487cd.svg";